import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { spWalletList } from 'src/app/modules/wallet/models/wallet.models'
import { ShowReasonPopupComponent } from '../show-reason-popup/show-reason-popup.component'
import { MatDialog } from '@angular/material/dialog'

@Component({
	selector: 'app-client-wallet-history',
	templateUrl: './client-wallet-history.component.html',
	styleUrls: ['./client-wallet-history.component.scss'],
})
export class ClientWalletHistoryComponent implements OnInit {
	@Input() walletDataTable: spWalletList[] = []
	@Input() selectedCountry!: number
	@Input() walletDataFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		activeTab: 0,
	}
	@Input() totalCount = 0
	@Output() actionChanged: EventEmitter<any> = new EventEmitter()

	constructor(public translate: TranslateService, private dialog: MatDialog) {}

	ngOnInit(): void {}
	viewReason(clientWalletData:spWalletList){
		this.dialog
		.open(ShowReasonPopupComponent, {
			width: '550px',
			height:'350px',
			data: {
				image: clientWalletData?.transactionType == 6 ? `assets/images/wallet-minus.svg` : `assets/images/empty-wallet-add.svg`,
				reason: clientWalletData?.reason,
				status:clientWalletData?.transactionType == 6 ? 'subtract':'add',
				availability:clientWalletData?.showToClient ? 'VISIBLE_AT_CLIENT' :'SHOWN_TO_ADMIN'

			},
		})
		.afterClosed()
		.subscribe({
			next: (res) => {
			
			},
		})
	}


}
